import { useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import React from 'react';
import { useMailbox } from '../../../../Mailboxes/Providers/NewMailboxProvider';

function MailItemMetaSender() {
	const { t } = useTranslation();
	const { isTiny, isSmall, isMedium } = useLayout();

	const { mailItemData } = useMailbox();

	return (
		<img
			src={`${mailItemData?.mailSender.logoPath}`}
			alt={mailItemData?.mailSender.name}
			className='round sm-shadow'
		/>
	);
}

export { MailItemMetaSender };
